/* eslint-disable camelcase */

enum B2BTrackingEvents {
  B2BItemImported = 'B2B Item Imported',
  B2BMatrixImported = 'B2B Matrix Imported',
}

export { B2BTrackingEvents };
